/* eslint-disable max-len */
import React, { useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import * as actions from '../action';
import * as c from '../constant';

import UpdateModal from '../components/UpdateModal';
import CreateModal from '../components/CreateModal';

function PurposeContainer({ getPinList, pinList }) {
  const setModal = useContext(ModalContext);

  const handleAddModal = e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <CreateModal />,
      title: 'Add Purpose',
      modalSize: 'modal-md',
    });
  };

  const handleEdit = data => e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <UpdateModal updateList={data.attributes} id={data.id} />,
      title: 'Update Purpose',
      modalSize: 'modal-md',
    });
  };

  const handleRemove = () => e => {
    
    e.preventDefault();
    ConfirmAlert(
      "Are you sure, you want to remove this mayor's permit fee?",
      () => {
        // removeMayorsPermitFee(data.id, () => {
        //   getMayorsPermitFeeList();
        //   const id = _.get(mayorsPermitFeeList, '0.id');
        //   history.push(`bpls/settings/mayorspermitfee/${id}`);
        // });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  useEffect(() => {
    getPinList();
    return () => {
      setModal({ isOpen: false });
    };
  }, []);

  return (
    <div className="card p-0">
      <div className="container-fluid">
        <div className="d-flex align-items-center p-4">
          <h3 className="mb-0">Purpose Settings - Birth Certificate</h3>
          <button
            type="button"
            onClick={handleAddModal}
            // disabled={pinList.length > 0}
            className="btn btn-primary cms-bg-color-primary cms-outline-primary  btn-round font-weight-bold ml-auto"
          >
            Add Purpose <i className="fas fa-plus" />
          </button>
        </div>
        <hr />
        <div className="row">
          <div className="col-12 py-3">
            <div className="w-100">
              <table className="w-100">
                <thead>
                  <tr>
                    <td className="pl-6">Purpose</td>

                    <td className="pr-6" />
                  </tr>
                </thead>
                <tbody>
                  {pinList.map(item => (
                    <tr key={item.id} className="top-border">
                      <td className="td-item pl-6">
                        {_.get(item, 'attributes.city_municipal') || '--'}
                      </td>

                      <td className="pr-6 d-flex justify-content-end">
                        <div className="">
                          <button
                            type="button"
                            className="btn-blank ml-auto"
                            onClick={handleEdit(item)}
                          >
                            <i className="far fa-edit icon-edit" />
                          </button>
                          <button
                            type="button"
                            className="btn-blank"
                            // onClick={handleRemove(mayorPermitFeeInfo)}
                            onClick={handleRemove()}
                          >
                            <i className="far fa-trash-alt icon-delete" />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

PurposeContainer.propTypes = {
  getPinList: PropTypes.instanceOf(Function).isRequired,
  pinList: PropTypes.instanceOf(Array).isRequired,
};

const mapStateToProps = ({ api }) => ({
  pinList: _.get(api, `${c.GET_PIN}.list`) || [],
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(PurposeContainer);
